import api from '../lib/axios';
export async function getDashboardStats() {
    const { data } = await api.get('/api/admin/stats/dashboard');
    return data.data;
}
export async function getTimeline(metric, days = 30) {
    const { data } = await api.get('/api/admin/stats/timeline', {
        params: { metric, days },
    });
    return data.data;
}
export async function getModuleStats(module) {
    const { data } = await api.get(`/api/admin/stats/module/${module}`);
    return data.data;
}
export async function getCommuneConfig() {
    const { data } = await api.get('/api/v1/commune/config');
    return data.data;
}
